export default __webpack_public_path__ + "static/media/our-process-03.16f390f6.png";